
const AppSettings = {
  appTitle: 'BelfastRapidTransit',
  siteAdmin: '',
  baseUrl: 'https://europe-west2-pinpoint-belfastrapidtransit.cloudfunctions.net/functions/',
  showFeedbackButton: false,
  showPostcodeFilter : false,
  showHelp: false,
  showUser: true,
  enableFilter: false,
  enableEntitySearch: false,
  enableChildrenCount: false,
  enableEntityPopup: true,
  parentChange: false,
  feedbackType: 'form',
  showMapKey: false,
  sateliteView: false,
  layerVisibilityToggle: false,
  imageMapKey: 'https://firebasestorage.googleapis.com/v0/b/pinpoint-pollokshaws.appspot.com/o/Toggle-key.png?alt=media&token=e161b8e4-b8a6-4d42-97fd-e6cc72ce74e1',
  imageMapKey: 'key.png',
  mapConfig: {
      accessToken:
        "pk.eyJ1IjoiY3JlYXRpdmUtZGVzaWduIiwiYSI6ImNqYXY0d3h2eTZ5M2syd2w5eWo3Ymd5bGIifQ.cYdELtP5xXELeUZ0p_cS_g",
      templatename: "mapbox://styles/creative-design/cknrljf410bba17pqfq7woslp/draft", ///draft", //"mapbox://styles/mapbox/light-v10", //"mapbox://styles/mapbox/basic-v9?optimize=true",
      startLocation:[ -5.919, 54.5996],
      startZoom: 12,
      startPitch: 0
     
    },

}; 

export default AppSettings;

